
// const StatisBar = () => {
//     return (
//         <section className="py-20">
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                 <div className="grid md:grid-cols-4 gap-8 text-center">
//                     <div className="border-l-2 border-l-blue-600 p-6">
//                         <div className="text-4xl font-bold text-primary mb-2">50+</div>
//                         <div className="text-gray-600">معلم مؤهل</div>
//                     </div>
//                     <div className="border-l-2 border-l-blue-600 p-6">
//                         <div className="text-4xl font-bold text-primary mb-2">1000+</div>
//                         <div className="text-gray-600">طالب مسجل</div>
//                     </div>
//                     <div className="border-l-2 border-l-blue-600 p-6">
//                         <div className="text-4xl font-bold text-primary mb-2">5000+</div>
//                         <div className="text-gray-600">درس مكتمل</div>
//                     </div>
//                     <div className="p-6">
//                         <div className="text-4xl font-bold text-primary mb-2">4.8</div>
//                         <div className="text-gray-600">تقييم المنصة</div>
//                     </div>
//                 </div>
//             </div>
//         </section>

//     )
// }

// export default StatisBar



import { FaUserMd, FaUsers, FaCalendarCheck, FaStar } from "react-icons/fa";

const StatisBar = () => {
  const stats = [
    { value: "50+", label: "طبيب متاح", icon: <FaUserMd className="w-14 h-14 mx-auto mb-3 text-gradient-blue" /> },
    { value: "2000+", label: "مريض مسجل", icon: <FaUsers className="w-14 h-14 mx-auto mb-3 text-gradient-green" /> },
    { value: "12000+", label: "موعد مكتمل", icon: <FaCalendarCheck className="w-14 h-14 mx-auto mb-3 text-gradient-purple" /> },
    { value: "4.9", label: "تقييم الخدمة", icon: <FaStar className="w-14 h-14 mx-auto mb-3 text-gradient-yellow" /> },
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-blue-50 via-blue-100 to-cyan-100 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-tr from-white/20 via-white/10 to-transparent pointer-events-none"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-16 text-blue-900 drop-shadow-md">
          إحصائياتنا
        </h2>
        <div className="grid md:grid-cols-4 gap-10 text-center">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="p-8 bg-white rounded-3xl shadow-lg hover:shadow-2xl border-l-8 border-l-blue-500 transform transition-all duration-500 hover:scale-105 cursor-pointer"
            >
              <div className="mb-4 transition-transform duration-500 hover:scale-110">{stat.icon}</div>
              <div className="text-5xl md:text-6xl font-extrabold text-blue-800 mb-2">{stat.value}</div>
              <div className="text-gray-700 font-medium text-lg">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatisBar;







// import { FaUserMd, FaUsers, FaCalendarCheck, FaStar } from "react-icons/fa";

// const StatisBar = () => {
//     const stats = [
//         { value: "50+", label: "طبيب متاح", icon: <FaUserMd className="w-12 h-12 mx-auto text-blue-500 mb-2" /> },
//         { value: "2000+", label: "مريض مسجل", icon: <FaUsers className="w-12 h-12 mx-auto text-green-500 mb-2" /> },
//         { value: "12000+", label: "موعد مكتمل", icon: <FaCalendarCheck className="w-12 h-12 mx-auto text-purple-500 mb-2" /> },
//         { value: "4.9", label: "تقييم الخدمة", icon: <FaStar className="w-12 h-12 mx-auto text-yellow-400 mb-2" /> },
//     ];

//     return (
//         <section className="py-20 bg-gradient-to-r from-blue-50 via-blue-100 to-cyan-100 shadow-lg">
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                 <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-blue-800">إحصائياتنا</h2>
//                 <div className="grid md:grid-cols-4 gap-8 text-center">
//                     {stats.map((stat, index) => (
//                         <div
//                             key={index}
//                             className="p-6 transition-transform transform hover:scale-105 rounded-2xl bg-white shadow-md hover:shadow-xl border-l-4 border-l-blue-500"
//                         >
//                             {stat.icon}
//                             <div className="text-5xl font-extrabold text-blue-800 mb-2">{stat.value}</div>
//                             <div className="text-gray-700 font-medium">{stat.label}</div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default StatisBar;







// import { FaUserMd, FaUsers, FaCalendarCheck, FaStar } from "react-icons/fa";

// const StatisBar = () => {
//     const stats = [
//         { value: "50+", label: "طبيب متاح", icon: <FaUserMd className="w-12 h-12 mx-auto text-blue-500 mb-2" /> },
//         { value: "2000+", label: "مريض مسجل", icon: <FaUsers className="w-12 h-12 mx-auto text-green-500 mb-2" /> },
//         { value: "12000+", label: "موعد مكتمل", icon: <FaCalendarCheck className="w-12 h-12 mx-auto text-purple-500 mb-2" /> },
//         { value: "4.9", label: "تقييم الخدمة", icon: <FaStar className="w-12 h-12 mx-auto text-yellow-400 mb-2" /> },
//     ];

//     return (
//         <section className="py-20 bg-gradient-to-r from-blue-50 via-blue-100 to-cyan-100 shadow-xl">
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                 <div className="grid md:grid-cols-4 gap-8 text-center">
//                     {stats.map((stat, index) => (
//                         <div
//                             key={index}
//                             className="p-8 transition-transform transform hover:scale-105 rounded-2xl bg-white shadow-lg border-l-8 border-l-blue-500"
//                         >
//                             {stat.icon}
//                             <div className="text-5xl font-extrabold text-blue-800 mb-2">{stat.value}</div>
//                             <div className="text-gray-700 font-medium">{stat.label}</div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default StatisBar;


